import { gsap } from 'gsap'
import { Draggable } from "gsap/Draggable"
import { startPopupOpenAnimation, closePopupOpenAnimation } from './popup-animation'

let timelinePopup = $('.js-timeline-popup')

function closePopups(el){
  if(timelinePopup.hasClass('open')) {
    timelinePopup.removeClass('open')
    let iframes = timelinePopup.find('iframe')
    if (iframes.length){ iframes.attr('src', '') }
    timelinePopup.find('.js-popup-content').html('')
    closePopupOpenAnimation()
    unbindSoundCloudWidget()
    setTimeout(function (){
      timelinePopup.find('.js-popup-content').html('<div class="spinner-centered">\n' +
        '                    <span class="spinner-loader reverse loading in-button"></span>\n' +
        '                </div>')
    }, 500)
  }
}

$('body').on('click', '.js-timeline-popup .js-close-popup', function(event) {
  closePopups($(this))
});

$(document).keyup(function(e) {
  if (e.key === "Escape") { // escape key maps to keycode `27`
    closePopups($(this))
  }
});

$('body').on('click', '.popup-video-preview', function (e){
  e.preventDefault()
  let container = $(this).parent()
  let video = container.find('iframe')
  let src = video[0].src
  if(src.search('youtube') >= 0) {
    video[0].src += "&autoplay=1";
  }

  $(this).fadeOut()
})

$('body').on('click', '#timeline-els .timeline-element', function(){
  let id = $(this).data('el-id')
  let year = $(this).data('element-year')
  //timelinePopup.addClass('open')
  $('.popup-active-year').text(year)

  startPopupOpenAnimation($(this).find('.timeline-element-description'))

  $.ajax({
    type: 'POST',
    url: ajaxurl,
    data: 'action=getTimelinePopupData&id='+id,
    success: function (results) {
      $('.js-popup-content').html($(results))


      let $popup_slider = $('.js-popup-content').find('.js-popup-gal')

      setTimeout(function (){

        $popup_slider = $('.js-popup-content').find('.js-popup-gal')

        if ($popup_slider.length) {

          let slickSlider = $popup_slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            infinite: true,
            dots: false
          })

          $popup_slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.js-cur-popup-gal-slide').text(nextSlide + 1)

            $('.gallery-image-slide').removeClass('active')
            $('.gallery-image-slide[data-slide-index="'+nextSlide+'"]').addClass('active')

            let navigation_container = $('.gallery-image-navigation')
            let navigation_slide_width = $('.gallery-image-navigation .gallery-image-slide').outerWidth()
            let maxLeft = ($('.navigation-draggable').width() - $('.gallery-image-navigation').width()) * -1

            if(navigation_container.length) {
              let leftLeftPost = nextSlide * navigation_slide_width
              if($('.navigation-draggable').width() > $('.gallery-image-navigation').width()) {
                let newPos = leftLeftPost * -1
                if(newPos < maxLeft) {
                  newPos = maxLeft
                }
                $('.navigation-draggable').css('transform', 'translate3d('+newPos+'px, 0px, 0px)')
              }
            }


          })

          $('body').on('click', '.slick-link', function (e){
            slickSlider.slick($(this).attr('data-action'));
          })

          $('body').on('click', '.gallery-image-slide', function (e){
            let index = parseInt($(this).attr('data-slide-index'))
            slickSlider.slick('slickGoTo', index, true);
          })

          //$('.js-popup-content').find('.popup-video').hide()



        }



        setupSoundCloudWidget($('.js-popup-content'))

        let draggable = $('.js-popup-content').find('.navigation-draggable')

        let right = draggable.width() - $(window).width()
        Draggable.create(".navigation-draggable", {type:"x", edgeResistance:0.65, bounds: {minX:0, maxX:-1*right}, inertia:true});

        let textLinks = $('.js-popup-content').find('.popup-text a')

        textLinks.each(function (e){
          $(this).addClass('nodeHover')
          $(this).attr('target', '_blank')
        })

      } , 250)


    }
  })


})

function showTimelinePopup()
{
  timelinePopup.addClass('open')
}

let widget = null

function setupSoundCloudWidget(container)
{

  var iframeElement = container.find('.popup-img-soundcloud-c iframe')[0];
  if(iframeElement) {

    widget = SC.Widget(iframeElement);
    widget.bind(SC.Widget.Events.READY, function() {

      container.find('.spinner-loader').removeClass('loading')

      $('.js-play-soundcloud, .soundcloud-layer-cover').click(function (e){
        let button = $(this)
        if(button.hasClass('playing')) {
          button.removeClass('playing')
          widget.pause()
        } else {
          button.addClass('playing')
          widget.play()
        }
      })

    })

  }
}

function unbindSoundCloudWidget()
{
  if(widget) {
    widget.unbind(SC.Widget.Events.READY)
  }

}

export { showTimelinePopup }